import PropTypes from 'prop-types';

import Box, { BoxProps as BoxProps } from '@mui/material/Box';
import { FullLogo } from '@classity-edtech/ui-base/dist/components/Displays';
import { styled } from '@mui/material/styles';
import { Icons } from '@classity-edtech/ui-base';
import { globalColours } from '@classity-edtech/ui-base/dist/style/source';
import { Link } from 'react-router-dom';
import ProfileDropdown from '../../ProfileDropdown';

export interface DashboardNavProps extends BoxProps {
  toggleSideNav?: () => void;
  isSEOPage: boolean;
}

export const DashboardNav = ({
  className,
  toggleSideNav,
  isSEOPage,
  ...props
}: DashboardNavProps) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 2,
        }}
        {...props}
      >
        <Link to={'/'}>
          <FullLogo
            sx={{
              width: 'auto',
              height: { xs: '28px', md: '40px' },
              cursor: 'pointer',
            }}
          />
        </Link>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <ProfileDropdown />
          {/* TODO: Control icon size using design token */}
          {!isSEOPage && (
            <Icons.MenuIcon
              sx={{
                width: '16px',
                height: '16px',
                cursor: 'pointer',
                display: { xs: 'block', md: 'none' },
                color: globalColours['$global-colour-interactive-primary-default'],
              }}
              onClick={toggleSideNav}
            />
          )}
        </Box>
      </Box>
    </>
  );
};

DashboardNav.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

DashboardNav.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(DashboardNav)(
  ({ theme }) => `
  &.MuiBox-root {
  }
`,
);
